<template>
  <div id="main">
    <div class="video-container">
      <video class="video" ref="myVideo" @click="playVideo"
             src="//download.wrightin.com/website/product-e10.mp4"
             muted autoplay loop
             :poster="require('@/assets/img/product/e10/video-cover.png')" @contextmenu.prevent
             playsinline preload="auto" x5-video-player-type="h5" webkit-playsinline="true" x5-playsinline="true"
             @pause="playState(false)" @play="playState(true)">
      </video>
      <img v-if="!isVideoPlaying" class="playBtn" @click.stop="playVideo"
           :src='require("@/assets/img/product/e10/play_circle.png")' />
      <div class="copyright">广告审查批准文号:苏械广审(视)第270213-02323号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20252090043  盆底评估训练软件:苏械注准20242212280<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用  禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司</div>
    </div>
    <div class="banner">
      <div id="bannerSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(bannerItem, bannerIndex) in bannerList" :key="bannerIndex">
            <div class="img-container">
              <img :src="bannerItem.path" alt="" />
              <div class="img-copyright" style="color: #ccc;" v-html="bannerItem.words"></div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <div class="stage-mode">
      <p class="title">盆底多周期训练</p>
      <div class="list">
        <img v-lazy='require("@/assets/img/product/e10/stage-1.png")' />
        <img v-lazy='require("@/assets/img/product/e10/stage-2.png")' />
        <img v-lazy='require("@/assets/img/product/e10/stage-3.png")' />
        <img v-lazy='require("@/assets/img/product/e10/stage-4.png")' />
      </div>
      <div class="img-copyright" style="line-height: 0.8rem;bottom: 0.4rem;">广告审查批准文号:苏械广审(文)第270527-12254号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20252090043 盆底评估训练软件:苏械注准20242212280<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司</div>
    </div>
    <div class="train">
      <p class="title">无械 + 有械</p>
      <p class="sub-title">科学多维 分阶修复</p>
      <div class="video-container-train">
        <video class="video" ref="myVideoTrain" @click="playVideoTrain"
               src="//download.wrightin.com/website/product-e10-1.mp4"
               poster="//download.wrightin.com/website/product-e10-1.mp4?x-oss-process=video/snapshot,t_0,f_jpg,m_fast"
               muted autoplay loop
               @contextmenu.prevent
               playsinline preload="auto" x5-video-player-type="h5" webkit-playsinline="true" x5-playsinline="true"
               @pause="playStateTrain(false)" @play="playStateTrain(true)">
        </video>
        <img v-if="!isVideoPlayingTrain" class="playBtn" @click.stop="playVideoTrain"
             :src='require("@/assets/img/product/e10/play_circle.png")' />
      </div>
      <div class="img-copyright" style="right: 2.6rem;">广告审查批准文号:苏械广审(视)第270213-02323号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20252090043<br/>盆底评估训练软件:苏械注准20242212280<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司</div>
    </div>
    <div class="no-equip">
      <p class="title">无械跟练</p>
      <p class="sub-title">定制课程，自主练习</p>
      <img v-lazy='require("@/assets/img/product/e10/no-equip.png")' />
      <div class="img-copyright" style="color: #ccc;">广告审查批准文号:苏械广审(文)第270213-02312号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20252090043 盆底评估训练软件:苏械注准20242212280<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司</div>
    </div>
    <div class="equip-train">
      <p class="title">有械训练 内外提升</p>
      <p class="sub-title"></p>
      <div id="equipSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(equipItem, equipIndex) in equipList" :key="equipIndex">
            <div class="img-container">
              <img :src="equipItem.path" alt="" />
            </div>
            <p class="title">{{ equipItem.title }}</p>
            <p class="desc">{{ equipItem.desc }}</p>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <div class="img-copyright" style="color: #ccc;">广告审查批准文号:苏械广审(文)第270207-02141号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20252090043 盆底评估训练软件:苏械注准20242212280<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司</div>
    </div>
    <div class="deal">
      <div class="item">
        <div class="text">
          <p class="title">治疗阴道松弛症</p>
        </div>
        <img v-lazy="require('@/assets/img/product/e10/train-floor.png')" class="img" />
        <div class="img-copyright" style="bottom: 0;color: #ccc;">广告审查批准文号:苏械广审(文)第270228-03665号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20252090043 盆底评估训练软件:苏械注准20242212280<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司</div>
      </div>
      <div class="item">
        <div class="text">
          <p class="title">腹直肌分离治疗</p>
        </div>
        <div class="video-container-fuzhiji">
          <video class="video" ref="myVideoFuzhiji" @click="playVideoFuzhiji"
                 src="//download.wrightin.com/website/product-e10-2.mp4"
                 poster="//download.wrightin.com/website/product-e10-2.mp4?x-oss-process=video/snapshot,t_0,f_jpg,m_fast"
                 muted autoplay loop
                 @contextmenu.prevent
                 playsinline preload="auto" x5-video-player-type="h5" webkit-playsinline="true" x5-playsinline="true"
                 @pause="playStateFuzhiji(false)" @play="playStateFuzhiji(true)">
          </video>
          <img v-if="!isVideoPlayingFuzhiji" class="playBtn" @click.stop="playVideoFuzhiji"
               :src='require("@/assets/img/product/e10/play_circle.png")' />
        </div>
        <div class="img-copyright" style="bottom: 0;color: #ccc;">广告审查批准文号:苏械广审(文)第270527-12256号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20252090043 盆底评估训练软件:苏械注准20242212280<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司</div>
      </div>
      <div class="item">
        <div class="text">
          <p class="title">生电联合技术</p>
          <p class="desc">激活细胞活性，肌肉收放自如</p>
        </div>
        <div class="video-container-tech">
          <video class="video" ref="myVideoTech" @click="playVideoTech"
                 src="//download.wrightin.com/website/product-e10-3.mp4"
                 poster="//download.wrightin.com/website/product-e10-3.mp4?x-oss-process=video/snapshot,t_0,f_jpg,m_fast"
                 muted autoplay loop
                 @contextmenu.prevent
                 playsinline preload="auto" x5-video-player-type="h5" webkit-playsinline="true" x5-playsinline="true"
                 @pause="playStateTech(false)" @play="playStateTech(true)">
          </video>
          <img v-if="!isVideoPlayingTech" class="playBtn" @click.stop="playVideoTech"
               :src='require("@/assets/img/product/e10/play_circle.png")' />
        </div>
        <div class="img-copyright" style="bottom: 0;color: #ccc;">广告审查批准文号:苏械广审(视)第270213-02323号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20252090043 盆底评估训练软件:苏械注准20242212280<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司</div>
      </div>
    </div>
    <div class="person">
      <p>贴心守护</p>
      <img v-lazy="require('@/assets/img/product/e10/person.png')" alt />
      <div class="img-copyright" style="color:#ccc; bottom: 0;">广告审查批准文号:苏械广审(文)第270513-10953号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20252090043 盆底评估训练软件:苏械注准20242212280<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司</div>
    </div>
    <div class="zhuanli">
      <p class="title">国家医疗器械认证</p>
      <p class="sub-title"></p>
      <div class="list">
        <div class="item">
          <img v-lazy="require('@/assets/img/product/e10/zhuanli-1.png')" class="img" />
          <p class="title">盆底康复治疗仪</p>
          <p class="desc">二类医疗器械</p>
        </div>
        <div class="item">
          <img v-lazy="require('@/assets/img/product/e10/zhuanli-2.png')" class="img" />
          <p class="title">盆底评估训练软件</p>
          <p class="desc">二类医疗器械</p>
        </div>
        <div class="item">
          <img v-lazy="require('@/assets/img/product/e10/zhuanli-3.png')" class="img" />
          <p class="title">阴道电极</p>
          <p class="desc">二类医疗器械</p>
        </div>
        <div class="item">
          <img v-lazy="require('@/assets/img/product/e10/zhuanli-4.png')" class="img" />
          <p class="title">理疗用体表电级</p>
          <p class="desc">一类医疗器械备案</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.css";

export default {
  data() {
    return {
      showCopyright: true,
      showCopyrightTimer: null,
      rem: document.documentElement.style.fontSize.replace("px", "") * 1,
      isVideoPlaying: false,
      isVideoPlayingTrain: false,
      isVideoPlayingFuzhiji: false,
      isVideoPlayingTech: false,
      bannerSwiper: null,
      bannerList: [
        {
          path: require("@/assets/img/product/e10/banner-1.png"),
          words: "广告审查批准文号:苏械广审(文)第270527-12254号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20252090043 盆底评估训练软件:苏械注准20242212280<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司"
        },
        {
          path: require("@/assets/img/product/e10/banner-2.png"),
          words: "广告审查批准文号:苏械广审(文)第270527-12254号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准20252090043 盆底评估训练软件:苏械注准20242212280<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司"
        }
      ],
      equipSwiper: null,
      equipList: [
        {
          path: require("@/assets/img/product/e10/equip-1.png"),
          title: "多维度盆底评估",
          desc: "标准快速筛查多维 盆底评估清晰呈现"
        },
        {
          path: require("@/assets/img/product/e10/equip-2.png"),
          title: "AI 定制专项方案",
          desc: "AI 大数据针对不同用户痛点 定制个性化训练方案"
        },
        {
          path: require("@/assets/img/product/e10/equip-3.png"),
          title: "腹肌监测",
          desc: "腹肌监测提醒 反馈腹肌参与情况"
        },
        {
          path: require("@/assets/img/product/e10/equip-4.png"),
          title: "六大训练模式",
          desc: "专项科学治疗 提升盆底肌群力"
        }
      ]
    };
  },
  mounted() {
    this.showCopyrightTimer = setTimeout(() => {
      this.showCopyright = false;
      clearTimeout(this.showCopyrightTimer);
    }, 5000);
    window.scrollTo(0, 0);
    setInterval(() => {
      this.pageScroll();
    }, 1000);
    this.bannerSwiper = new Swiper("#bannerSwiper", {
      loop: true, // 循环模式
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }
    });
    this.equipSwiper = new Swiper("#equipSwiper", {
      loop: true, // 循环模式
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }
    });
  },
  methods: {
    pageScroll() {
      // 判断 video是不是被 header sh
      const videoDom = document.querySelector(".video-container");
      const headerDom = document.querySelector("#top");
      if (videoDom && headerDom && this.$refs.myVideo) {
        // videoDom 在 屏幕中间
        if (videoDom.getBoundingClientRect().top + videoDom.getBoundingClientRect().height / 2 > headerDom.getBoundingClientRect().height &&
          window.innerHeight - videoDom.getBoundingClientRect().top > videoDom.getBoundingClientRect().height / 2) {
        } else {
          this.$refs.myVideo.pause();
          this.isVideoPlaying = false;
        }
      }
      const videoDomTrain = document.querySelector(".video-container-train");
      if (videoDomTrain && headerDom && this.$refs.myVideoTrain) {
        // videoDom 在 屏幕中间
        if (videoDomTrain.getBoundingClientRect().top + videoDomTrain.getBoundingClientRect().height / 2 > headerDom.getBoundingClientRect().height &&
          window.innerHeight - videoDomTrain.getBoundingClientRect().top > videoDomTrain.getBoundingClientRect().height / 2) {
        } else {
          this.$refs.myVideoTrain.pause();
          this.isVideoPlayingTrain = false;
        }
      }
      const videoDomFuzhiji = document.querySelector(".video-container-fuzhiji");
      if (videoDomFuzhiji && headerDom && this.$refs.myVideoFuzhiji) {
        // videoDom 在 屏幕中间
        if (videoDomFuzhiji.getBoundingClientRect().top + videoDomFuzhiji.getBoundingClientRect().height / 2 > headerDom.getBoundingClientRect().height &&
          window.innerHeight - videoDomFuzhiji.getBoundingClientRect().top > videoDomFuzhiji.getBoundingClientRect().height / 2) {
        } else {
          this.$refs.myVideoFuzhiji.pause();
          this.isVideoPlayingFuzhiji = false;
        }
      }
      const videoDomTech = document.querySelector(".video-container-tech");
      if (videoDomTech && headerDom && this.$refs.myVideoTech) {
        // videoDom 在 屏幕中间
        if (videoDomTech.getBoundingClientRect().top + videoDomTech.getBoundingClientRect().height / 2 > headerDom.getBoundingClientRect().height &&
          window.innerHeight - videoDomTech.getBoundingClientRect().top > videoDomTech.getBoundingClientRect().height / 2) {
        } else {
          this.$refs.myVideoTech.pause();
          this.isVideoPlayingTech = false;
        }
      }
    },
    playState(isPlay) {
      this.isVideoPlaying = isPlay;
      this.showCopyright = true;
      if (isPlay) {
        this.$refs.myVideo.setAttribute("controls", "true");
        this.showCopyrightTimer = setTimeout(() => {
          this.showCopyright = false;
          clearTimeout(this.showCopyrightTimer);
        }, 5000);
      } else {
        this.$refs.myVideo.removeAttribute("controls");
      }
    },
    playVideo() {
      this.$refs.myVideo.muted = false;
      this.$refs.myVideo.play();
    },
    playStateTrain(isPlay) {
      this.isVideoPlayingTrain = isPlay;
      if (isPlay) {
        this.$refs.myVideoTrain.setAttribute("controls", "true");
      } else {
        this.$refs.myVideoTrain.removeAttribute("controls");
      }
    },
    playVideoTrain() {
      this.$refs.myVideoTrain.muted = false;
      this.$refs.myVideoTrain.play();
    },
    playStateFuzhiji(isPlay) {
      this.isVideoPlayingFuzhiji = isPlay;
      if (isPlay) {
        this.$refs.myVideoFuzhiji.setAttribute("controls", "true");
      } else {
        this.$refs.myVideoFuzhiji.removeAttribute("controls");
      }
    },
    playVideoFuzhiji() {
      this.$refs.myVideoFuzhiji.muted = false;
      this.$refs.myVideoFuzhiji.play();
    },
    playStateTech(isPlay) {
      this.isVideoPlayingTech = isPlay;
      if (isPlay) {
        this.$refs.myVideoTech.setAttribute("controls", "true");
      } else {
        this.$refs.myVideoTech.removeAttribute("controls");
      }
    },
    playVideoTech() {
      this.$refs.myVideoTech.muted = false;
      this.$refs.myVideoTech.play();
    }
  }
};
</script>

<style lang="scss" scoped>
#main {
  background-color: #fff;
}

.video-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  > .video {
    width: 100%;
    object-fit: cover;
  }

  > .playBtn {
    position: absolute;
    width: 4.4rem;
  }

  >.copyright {
    position: absolute;
    bottom: 1.2rem;
    left: 0;
    width: 100%;
    padding: 0 2%;
    font-weight: 400;
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.6);
    line-height: 1.2rem;
    pointer-events: none;
  }
}

.banner {
  width: 100%;
  background: #fff;
  position: relative;
  overflow: hidden;

  > #bannerSwiper {
    width: 100%;
    height: 66.7rem;
    position: relative;
    margin: 0 auto;
    overflow: hidden;

    .swiper-slide {
      position: relative;

      > .img-container {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: absolute;

        > img {
          width: 100%;
        }
      }

    }

    .swiper-pagination {
      bottom: 4rem;
    }

    /deep/ .swiper-pagination-bullet {
      background: transparent;     /* 改成透明 = 空心 */
      border: 0.1rem solid #fff;    /* 白色边框 */
      opacity: 1;
      margin: 0 0.6rem;
    }

    /deep/ .swiper-pagination-bullet-active {
      background: #fff;             /* 选中 = 白色实心 */
      border: 0.1rem solid transparent;
    }
  }
}

.stage-mode {
  width: 100%;
  background: url('../../assets/img/product/e10/stage-bg.png') no-repeat center center;
  background-size: 100% 100%;
  position: relative;
  overflow: hidden;
  height: 99.2rem;

  > .title {
    padding: 5.2rem 0;
    text-align: center;
    width: 100%;
    font-weight: 500;
    font-size: 1.8rem;
    color: #000000;
    line-height: 2.5rem;
  }

  > .list {
    width: 100%;
    padding: 0 1.6rem;

    > img {
      width: 100%;
      margin-bottom: 1.6rem;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.train {
  width: 100%;
  height: 52.9rem;
  position: relative;
  overflow: hidden;
  background: #fff;

  > .title {
    margin-top: 4rem;
    width: 100%;
    text-align: center;
    font-weight: 500;
    font-size: 1.8rem;
    color: #000000;
    line-height: 2.5rem;
  }

  > .sub-title {
    width: 100%;
    text-align: center;
    font-weight: 500;
    font-size: 1.4rem;
    color: #000000;
    line-height: 2rem;
  }

  .video-container-train {
    margin-top: 4rem;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 1.6rem;

    > .video {
      width: 100%;
      height: 40rem;
      object-fit: cover;
      border-radius: 2rem;
    }

    > .playBtn {
      position: absolute;
      width: 4.4rem;
    }
  }
}

.no-equip {
  width: 100%;
  height: 59.5rem;
  position: relative;
  overflow: hidden;
  background: #FAFBFE;

  > .title {
    margin-top: 4rem;
    width: 100%;
    text-align: center;
    font-weight: 500;
    font-size: 1.8rem;
    color: #000000;
    line-height: 2.5rem;
  }

  > .sub-title {
    width: 100%;
    text-align: center;
    font-weight: 500;
    font-size: 1.4rem;
    color: #000000;
    line-height: 2rem;
  }

  > img {
    width: 100%;
    margin-top: 4rem;
  }
}

.equip-train {
  width: 100%;
  height: 51.1rem;
  position: relative;
  overflow: hidden;
  background: #FFFFFF;

  > .title {
    margin-top: 4rem;
    width: 100%;
    text-align: center;
    font-weight: 500;
    font-size: 1.8rem;
    color: #000000;
    line-height: 2.5rem;
  }

  > .sub-title {
    width: 100%;
    text-align: center;
    font-weight: 500;
    font-size: 1.4rem;
    color: #000000;
    line-height: 2rem;
  }

  > #equipSwiper {
    width: 100%;
    height: 34.2rem;
    position: relative;
    margin: 4rem auto;
    overflow: hidden;

    .swiper-slide {
      position: relative;
      padding: 0 1.6rem;

      > .img-container {
        width: 34.4rem;
        height: 32.2rem;
        overflow: hidden;
        position: absolute;
        background: #F5F5F7;
        border-radius: 2rem;

        > img {
          width: 100%;
          height: 25.67rem;
        }
      }

      > .title {
        position: absolute;
        bottom: 5.3rem;
        width: 34.4rem;
        font-weight: 500;
        font-size: 1.4rem;
        color: #000000;
        line-height: 2rem;
        text-align: center;
      }

      > .desc {
        position: absolute;
        bottom: 3.2rem;
        width: 34.4rem;
        font-size: 1.2rem;
        color: #666;
        line-height: 1.7rem;
        text-align: center;
      }
    }

    .swiper-pagination {
      bottom: 0rem;
    }

    /deep/ .swiper-pagination-bullet {
      background: transparent;     /* 改成透明 = 空心 */
      border: 0.1rem solid #fff;    /* 白色边框 */
      opacity: 1;
      margin: 0 0.6rem;
    }

    /deep/ .swiper-pagination-bullet-active {
      background: #fff;             /* 选中 = 白色实心 */
      border: 0.1rem solid transparent;
    }
  }
}

.deal {
  width: 100%;
  background: #FFFFFF;
  overflow: hidden;
  position: relative;

  > .item {
    padding: 0 1.6rem 5.1rem;
    position: relative;

    &:nth-child(1) {
      > .text {
        margin-top: 0;
      }
    }

    > .text {
      margin: 2.4rem 0;

      > .title {
        width: 100%;
        font-weight: 500;
        font-size: 1.4rem;
        color: #000000;
        line-height: 2rem;
        text-align: center;
      }

      > .desc {
        margin-top: 0.4rem;
        width: 100%;
        font-size: 1.2rem;
        color: #666666;
        line-height: 1.7rem;
        text-align: center;
      }
    }

    > .img {
      width: 100%;
      object-fit: cover;
      border-radius: 2rem;
    }

    > .video-container-fuzhiji {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      > .video {
        width: 100%;
        object-fit: cover;
        border-radius: 2rem;
      }

      > .playBtn {
        position: absolute;
        width: 4.4rem;
      }
    }

    > .video-container-tech {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      > .video {
        width: 100%;
        height: 40rem;
        object-fit: cover;
        border-radius: 2rem;
      }

      > .playBtn {
        position: absolute;
        width: 4.4rem;
      }
    }
  }
}

.person {
  position: relative;
  width: 100%;
  background: #fff;
  padding: 4rem 1.6rem 5.1rem;

  > p {
    font-weight: 500;
    font-size: 1.8rem;
    color: #000000;
    line-height: 2.5rem;
    text-align: center;
    margin-bottom: 4rem;
  }

  > img {
    width: 100%;
  }
}

.zhuanli {
  position: relative;
  width: 100%;
  height: 58.3rem;
  background: #FAFBFE;

  > .title {
    position: absolute;
    top: 4rem;
    width: 100%;
    font-weight: 500;
    font-size: 1.8rem;
    color: #000000;
    line-height: 2.5rem;
    text-align: center;
  }

  > .sub-title {
    position: absolute;
    top: 6.9rem;
    width: 100%;
    font-weight: 500;
    font-size: 1.4rem;
    color: #000;
    line-height: 2rem;
    text-align: center;
  }

  > .list {
    position: absolute;
    top: 12.9rem;
    padding: 0 0.7rem 4rem 1.6rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    row-gap: 2.4rem;

    > .item {
      width: 11.62rem;

      > .img {
        width: 11.62rem;
        height: 14.72rem;
      }

      > .title {
        font-weight: 500;
        font-size: 1.3rem;
        color: #000000;
        line-height: 1.8rem;
        text-align: center;
        white-space: nowrap;
        padding-right: 0.9rem;
        margin-top: 0.9rem;
      }

      > .desc {
        font-size: 1.1rem;
        color: #999;
        line-height: 1.5rem;
        text-align: center;
        white-space: nowrap;
        padding-right: 0.9rem;
        margin-top: 0.6rem;
      }
    }
  }
}
</style>
